import { fetchClient } from "../generated/client";
import type {
  DateFilterCondition,
  DateFilterValue,
  StringFilterCondition,
  StringFilterValue,
} from "./use-return-requests";

export type StringFrontFilterValue = {
  condition: StringFilterCondition;
  value: string[];
};
export type DateFrontFilterValueType = "1d" | "3d" | "1w" | "1m" | "3m";
export type DateFrontFilterValue = {
  condition: DateFilterCondition;
  value: DateFrontFilterValueType;
};
export type StringFilterName =
  | "status"
  | "resolution"
  | "assignee"
  | "reason"
  | "country"
  | "returnStore"
  | "warehouse";
export type DateFilterName = "createdDate";
export type FilterName = StringFilterName | DateFilterName;
type QuickFilter = "toBeValidated" | "toBeTreated";
type DownloadReturnRequestsParams = {
  quickFilter?: QuickFilter | null;
  shopId: string;
  fields: string[];
  separator?: string | null;
  filters?: {
    status?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    reason?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    country?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    assignee?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    createdDate?: {
      condition: DateFilterCondition;
      value: DateFilterValue;
    };
    treatedMerchantDate?: {
      condition: DateFilterCondition;
      value: DateFilterValue;
    };
    treatedLogisticianDate?: {
      condition: DateFilterCondition;
      value: DateFilterValue;
    };
    resolution?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    returnStore?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
    warehouse?: {
      condition: StringFilterCondition;
      value: StringFilterValue;
    };
  };
  sortBy?:
    | "createdAt"
    | "orderName"
    | "logisticianTreatedAt"
    | "merchantTreatedAt"
    | "shippedAt"
    | "shippingAt"
    | null;
  sortOrder?: "asc" | "desc" | null;
};

export async function downloadReturnRequests({
  shopId,
  filters,
  sortBy,
  sortOrder,
  fields,
  quickFilter,
  separator,
}: DownloadReturnRequestsParams) {
  try {
    const query: Record<string, string | string[]> = {};

    if (quickFilter) query.quickFilter = quickFilter;
    query.shopId = shopId;
    if (sortBy) query.sortBy = sortBy;
    if (sortOrder) query.sortOrder = sortOrder;
    if (fields.length) query.fields = fields;
    if (separator) query.separator = separator;

    if (filters?.status?.condition)
      query.statusCondition = filters.status.condition;
    if (filters?.status?.value) query.statusValue = filters.status.value;
    if (filters?.reason?.condition)
      query.reasonCondition = filters.reason.condition;
    if (filters?.reason?.value) query.reasonValue = filters.reason.value;
    if (filters?.country?.condition)
      query.countryCondition = filters.country.condition;
    if (filters?.country?.value) query.countryValue = filters.country.value;
    if (filters?.assignee?.condition)
      query.assigneeCondition = filters.assignee.condition;
    if (filters?.assignee?.value) query.assigneeValue = filters.assignee.value;
    if (filters?.createdDate?.condition)
      query.createdDateCondition = filters.createdDate.condition;
    if (filters?.createdDate?.value)
      query.createdDateValue = filters.createdDate.value;
    if (filters?.treatedMerchantDate?.condition)
      query.treatedMerchantDateCondition =
        filters.treatedMerchantDate.condition;
    if (filters?.treatedMerchantDate?.value)
      query.treatedMerchantDateValue = filters.treatedMerchantDate.value;
    if (filters?.treatedLogisticianDate?.condition)
      query.treatedLogisticianDateCondition =
        filters.treatedLogisticianDate.condition;
    if (filters?.treatedLogisticianDate?.value)
      query.treatedLogisticianDateValue = filters.treatedLogisticianDate.value;
    if (filters?.resolution?.condition)
      query.resolutionCondition = filters.resolution.condition;
    if (filters?.resolution?.value)
      query.resolutionValue = filters.resolution.value;
    if (filters?.returnStore?.condition)
      query.returnStoreCondition = filters.returnStore.condition;
    if (filters?.returnStore?.value)
      query.returnStoreValue = filters.returnStore.value;
    if (filters?.warehouse?.condition)
      query.locationCondition = filters.warehouse.condition;
    if (filters?.warehouse?.value)
      query.locationValue = filters.warehouse.value;

    await fetchClient.GET("/shops/{shopId}/return-requests/download", {
      params: {
        path: { shopId },
        query,
      },
    });
  } catch (error) {
    console.error(error);
    return;
  }
}
